import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "row justify-between items-center" }
const _hoisted_2 = { class: "text-body1" }

import { EmitValue, PropValue, useValue } from 'SharedDir/common/composables/useValue';
import ParametersSet from 'SharedComponents/Fields/FieldParams/ParametersSet.vue';
import SBtn from 'SharedComponents/ui/Button/SBtn.vue';
import { FieldParameter } from 'SharedDir/declarations/fields';
import { Json } from 'SharedDir/declarations/shared';

export interface Props extends PropValue<null | Array<Json>> {
  readonly?: boolean;
  label: string;
  itemType: Array<FieldParameter>;
}

export default /*@__PURE__*/_defineComponent({
  ...{ name: 'ArrayOfParameter' },
  __name: 'ArrayOf',
  props: {
    readonly: { type: Boolean, default: false },
    label: {},
    itemType: {},
    modelValue: {}
  },
  emits: ["update:modelValue"],
  setup(__props: any, { emit: __emit }) {


const props = __props;
const emit = __emit;
const { innerValue, emitValue } = useValue(props, emit, { transform: (v) => v ?? [] });

const itemDefaultValue = () => {
  return Object.fromEntries(
    props.itemType.map(({ name, defaultValue }) => [
      name,
      (defaultValue || null) as unknown as Json,
    ])
  );
};
const addItem = () => {
  innerValue.value.push(itemDefaultValue());
};

const removeItem = (index: number) => {
  innerValue.value.splice(index, 1);
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_ctx.label), 1),
      _createVNode(SBtn, {
        disable: _ctx.readonly,
        type: "brand",
        icon: "add",
        onClick: addItem
      }, null, 8, ["disable"])
    ]),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(innerValue), (item, index) => {
      return (_openBlock(), _createElementBlock("div", {
        key: index,
        class: "row s-bordered base-padding base-margin-bottom"
      }, [
        _createVNode(ParametersSet, {
          modelValue: _unref(innerValue)[index],
          "onUpdate:modelValue": [($event: any) => ((_unref(innerValue)[index]) = $event), _unref(emitValue)],
          class: "col",
          readonly: _ctx.readonly,
          set: _ctx.itemType
        }, null, 8, ["modelValue", "onUpdate:modelValue", "readonly", "set"]),
        _createVNode(SBtn, {
          disable: _ctx.readonly,
          type: "icon",
          class: "danger base-margin-left",
          icon: "las la-trash-alt",
          onClick: ($event: any) => (removeItem(index))
        }, null, 8, ["disable", "onClick"])
      ]))
    }), 128))
  ]))
}
}

})